<hsuc-safe-script [scriptCode]="safeHtml"></hsuc-safe-script>
<lib-element-error-text
  [validationError]="validationError()"
></lib-element-error-text>